export default class TimerEvent {
    constructor(type) {
        this.type = type;
    }
}

TimerEvent.START_TIMER = "TimerEvent.START_TIMER";
TimerEvent.STOP_TIMER = "TimerEvent.STOP_TIMER";
TimerEvent.PAUSE_TIMER = "TimerEvent.PAUSE_TIMER";
TimerEvent.RESTART_TIMER = "TimerEvent.RESTART_TIMER";